import { useMutation, useQuery, UseQueryOptions } from "react-query";
import { getSubjects, sendContact } from "../services/contactForm.service";
import { ISelectOption } from "../../components/Forms/Select/Select.interface";
import { IContact } from "../interfaces/contacts.interface";

export function useGetSubjects<T extends any = ISelectOption[]>(
    locale: string,
    options?: UseQueryOptions<any, unknown, T>
) {
    return useQuery({
        queryKey: ["subjects", locale],
        queryFn: () => getSubjects(locale),
        retry: 0,
        refetchOnWindowFocus: false,
        staleTime: 15 * 60 * 1000,
        ...options
    });
}

export function useSendContact() {
    return useMutation(({ contact, locale }: { contact: IContact, locale: string }) => sendContact(contact, locale))
}

